import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
  async fetchTechnologicalDetails({ dispatch }) {
    const { data, status } = await Vue.axios.get("/technological_developments_details");
    if (status != 200) {
      await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
    };
    return { data, status };
  },
  async createTechnologicalDetails({ dispatch }, technologicalDevelopmentsDetails) {
    const formData = new FormData();
    formData.append('file_icon', technologicalDevelopmentsDetails.file_icon);
    formData.append('request', technologicalDevelopmentsDetails.request);
    formData.append('description', technologicalDevelopmentsDetails.description);
    formData.append('btn_text', technologicalDevelopmentsDetails.btn_text);
    formData.append('url_page', technologicalDevelopmentsDetails.url_page);
    formData.append('url_appstore', technologicalDevelopmentsDetails.url_appstore);
    formData.append('url_googleplay', technologicalDevelopmentsDetails.url_googleplay);
    formData.append('id_all_developments', technologicalDevelopmentsDetails.id_all_developments);

    const { data, status } = await Vue.axios.post("/technological_developments_details", formData);
    if (status != 200 && status != 201) {
      await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
    } else {
      await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
    }
    return { data, status };
  },
  async updateTechnologicalDetails({ dispatch }, technologicalDevelopmentsDetails) {
    const formData = new FormData();
    formData.append('request', technologicalDevelopmentsDetails.request);
    formData.append('description', technologicalDevelopmentsDetails.description);
    formData.append('btn_text', technologicalDevelopmentsDetails.btn_text);
    formData.append('url_page', technologicalDevelopmentsDetails.url_page);
    formData.append('url_appstore', technologicalDevelopmentsDetails.url_appstore);
    formData.append('url_googleplay', technologicalDevelopmentsDetails.url_googleplay);
    formData.append('id_all_developments', technologicalDevelopmentsDetails.id_all_developments);
    if (technologicalDevelopmentsDetails.file_icon) {
      formData.append('file_icon', technologicalDevelopmentsDetails.file_icon)
    }
    const { data, status } = await Vue.axios.post(`/technological_developments_details/${technologicalDevelopmentsDetails.id}`, formData);
    if (status != 200 && status != 201 && status != 204) {
      await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
    } else {
      await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
    }
    return { data, status };
  },
  async removeTechnologicalDetails({ dispatch }, technologicalDevelopmentsDetails) {
    const { data, status } = await Vue.axios.delete(`/technological_developments_details/${technologicalDevelopmentsDetails.id}`);
    if (status != 200 && status != 204) {
      await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
    } else {
      await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
    }
    return { data, status };
  }
}

export default { state, mutations, actions }
